import React, { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { isTeamMemberWithRouteRestrictions } from '../../utils/regBranchRouteAccess';

const Header = () => {
  const navigate = useNavigate();
  const { branchSessionLogout, regBranchSession } = useContext(GlobalStateDataContext);

  const headerTitle = useMemo(() => {
    const isTeamMember = isTeamMemberWithRouteRestrictions(regBranchSession);
    if (isTeamMember) {
      const info = regBranchSession?.teamInfo;
      const name = [info?.firstName, info?.lastName].filter(Boolean).join(' ').trim();
      return {
        prefix: name ? `${name} (Team member) —` : 'Team Member —',
        highlight: 'Workspace',
      };
    }
    return {
      prefix: 'Regional Branch Management —',
      highlight: 'Dashboard',
    };
  }, [regBranchSession]);

  const btnBase = {
    cursor: 'pointer',
    borderRadius: '5px',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '14px',
    padding: '8px 14px',
  };

  return (
    <header
      style={{
        height: 50,
        backgroundColor: '#181436',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        position: 'sticky',
        top: 0,
        borderBottom: '2px solid hwb(23 16% 0%)',
        zIndex: 12,
      }}
    >
      <button
        type="button"
        style={{
          ...btnBase,
          color: '#091057',
          backgroundColor: '#E3EEB2',
          border: '1px solid #E3EEB2',
          minWidth: '88px',
        }}
        onClick={() => {
          navigate('/');
        }}
      >
        Home
      </button>
      <div style={{ color: 'white', textAlign: 'center', flex: 1, padding: '0 12px' }}>
        {headerTitle.prefix}{' '}
        <span style={{ color: '#E3EEB2', fontFamily: 'Inter Medium' }}>{headerTitle.highlight}</span>
      </div>
      <button
        type="button"
        style={{
          ...btnBase,
          color: 'white',
          backgroundColor: 'transparent',
          border: '1px solid rgba(227, 238, 178, 0.6)',
        }}
        onClick={() => branchSessionLogout(navigate)}
      >
        Log out
      </button>
    </header>
  );
};

export default Header;
